import React from "react"
const Shimmer = () => {
    return (
        <div className="m-4 p-4 w-[220px] rounded-2xl h-[350px]" style={{backgroundColor:"#f0f0f0"}}>
            <div className="card-content">
            </div>
        </div>
    )
}

export default Shimmer;
